// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: util/uuid_util/lcmtypes/uuid_util.lcm

import { uint16_t } from "@skydio/lcm/src/types";
import { uint8_t } from "@skydio/lcm/src/types";

import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmMsg from "@skydio/lcm/src/lcm";
import ReflectionMeta from "@skydio/lcm/src/reflection";

export class uuid_t extends LcmMsg {

  private static _hash = Long.fromString("18106864277434736559", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (uuid_t._packed_fingerprint === undefined) {
      uuid_t._packed_fingerprint = uuid_t._get_hash_recursive([]);
    }
    return uuid_t._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(uuid_t) > -1) {
      return Long.fromNumber(0, true);
    }
    let tmp_hash = uuid_t._hash;
    return tmp_hash.shl(1).add(tmp_hash.shru(63));
  }

  /** @internal */
  public static override _reflection_meta: ReflectionMeta = {
    data: { kind: "array", dims: [{ kind: "fixed", size: 16 }], nDim: 1, inner: { kind: "primitive", type: Number, typeStr: "uint8_t" } },
  };

  public static kUUIDSize: uint16_t = 16;
  public data: uint8_t[];

  public override decode(byte_array: Uint8Array): uuid_t {
    const decoder = new Decoder(new DataView(
      byte_array.buffer, byte_array.byteOffset, byte_array.byteLength
    ));
    const hash = decoder.decode_hash();
    if (!hash.equals(uuid_t._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, uuid_t._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  public override decode_one(decoder: Decoder): uuid_t {
    this.data = new Array(16);
    for (let i0 = 0; i0 < 16; i0++) {
      this.data[i0]! = decoder.decode_uint8_t();
    }
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    let total_size = 0;
    total_size += 8 * 16;
    return total_size;
  }

  public override encode(): ArrayBufferLike {
    const encoder = new Encoder(8 + this._get_encoded_size()); // hash + rest
    encoder.encode_hash(uuid_t._get_packed_fingerprint());
    this.encode_one(encoder);

    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    for (let i0 = 0; i0 < 16; i0++) {
      encoder.encode_uint8_t(this.data[i0]!);
    }
  }

  constructor(init?: {data?: uint8_t[] }) {
    super();
    this.data = new Array(16).fill(0);

    // optionally override default values
    if (!init) {
      return;
    }
    this.data = init.data || this.data;
  }
}